import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';

@Component({
    selector: 'app-flags',
    templateUrl: './flags.component.html',
    styleUrls: ['./flags.component.scss'],
    standalone: false
})
export class FlagsComponent implements OnInit {
  @Input() config: any = {};
  currentConfig: any = {};
  static itemFlagsValue: any = null;
  static itemFlagValueSet: Promise<any> = null;

  constructor(public baseService: BaseService, private cdr: ChangeDetectorRef) { }

  get isNonFormulary(): boolean {
    const data = this.config?.item?.mixdata != null ? this.config.item.mixdata : this.config?.item;
    return data?.isFormulary === 'Non Formulary'; 
  }

  ngOnInit(): void {
    //setting data 
    this.currentConfig['data'] = this.config.item != undefined && this.config.item.mixdata != undefined ? this.config.item.mixdata : this.config.item;
    this.currentConfig.details = [];
    //check to show or not to show flag
    this.showFlag(this.currentConfig['data'], this.config.setting);
    // itemFlag Valueset Api
    this.getItemFlagsValueset().then(() => {
      this.applyFlagColors();
      if (!this.currentConfig.showFlag) {
        this.showFlagFromValueset();
      }
      if (!this.cdr['destroyed']) {
        this.cdr.detectChanges();
      }
    });
  }

  // NABH Work
  getItemFlagsValueset(): Promise<any> {
    if (!FlagsComponent.itemFlagValueSet) {
      FlagsComponent.itemFlagValueSet = new Promise((resolve) => {
        let data = {
          'args': 'resourceId:item-itemFlag,system:karexpert',
          'query_id': 'get_valueset_by_id_flat'
        };
        this.baseService.getData(data, '', 'valueset', 'system-management', 'get_valueset_by_id_flat').subscribe(
          result => {
            if (result.errCode == 0 && result.resource.length > 0) {
              FlagsComponent.itemFlagsValue = result.resource;
            }
            console.log("FlagsComponent.itemFlagsValue--", FlagsComponent.itemFlagsValue);
            
            resolve(FlagsComponent.itemFlagsValue);
          }
        );
      });
    }
    return FlagsComponent.itemFlagValueSet;
  }

  showFlagFromValueset() {
    const item = this.currentConfig['data'];
    if (!item?.itemFlag || !FlagsComponent.itemFlagsValue) return;
    const flags = Array.isArray(item.itemFlag) ? item.itemFlag : [item.itemFlag];
    const allFlagText = flags.map((f: any) => f.text || f.id).reverse().join(',');
    const conditions: any[] = this.config.setting?.conditions || [];
    for (const flag of flags) {
      const match = FlagsComponent.itemFlagsValue.find((v: any) => v.code === flag.id);
      if (match?.meta) {
        try {
          const meta = typeof match.meta === 'string' ? JSON.parse(match.meta) : match.meta;
          if (meta.color_code) {
            const cond = conditions.find(
              (c: any) => typeof c.expression === 'string' && c.expression.includes(`'${flag.id}'`)
            );
            const cssClass = cond?.class || 'grid-high-icon';
            this.currentConfig.showFlag = true;
            if (this.currentConfig.details.length == 0 ) {
              this.currentConfig.details.push({ flagValue: allFlagText, color: meta.color_code, class: cssClass });
            }
          }
        } catch (e) {
          console.error('Error parsing flag meta in showFlagFromValueset:', e);
        }
      }
    }
  }

  applyFlagColors() {
    if (!FlagsComponent.itemFlagsValue || !this.currentConfig.details) return;
    let item = this.currentConfig['data'];
    for (let detail of this.currentConfig.details) {
      detail.color = this.getFlagColor(item);
    }
  }
  getFlagColor(item: any): string | null {
    try {
      if (!FlagsComponent.itemFlagsValue || !item?.itemFlag) return null;
      for (let flag of item.itemFlag) {
        let match = FlagsComponent.itemFlagsValue.find(v => v.code === flag.id);
        if (match && match.meta) {
          let meta = typeof match.meta === 'string' ? JSON.parse(match.meta) : match.meta;
          if (meta.color_code) {
            return meta.color_code;
          }
        }
      }
    } catch (e) {
      console.error('Error parsing flag meta:', e);
    }
    return null;
  }

  showFlag(data, condition) {
    this.currentConfig.showFlag = false;
    if (condition != undefined && condition.conditions != undefined) {
      let item = data;
      for (let currentCondt of condition.conditions) {
        if (eval(currentCondt.expression)) {
          this.currentConfig.showFlag = true;
          this.currentConfig.val = {};
          this.currentConfig.val.flagValue = eval(currentCondt.format)(item);
          if (condition.all_condition) {
            if (currentCondt.img)
              this.currentConfig.val.img = currentCondt.img;
            this.currentConfig.details.push(this.currentConfig.val);
          }else{
            this.currentConfig.val.flagValue = eval(currentCondt.format)(item);
            if (currentCondt.img)
              this.currentConfig.val.img = currentCondt.img;
            this.currentConfig.details.push(this.currentConfig.val);
            break;
          }
        }
      }
    }
  }

  getImageFlag(data) {
    if (data.showFlag) {

    }
    console.log(data);
  }

}
